import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'pokedex',
  name: 'Pokédex & Team Builder',
  description: 'Search for any Pokémon to show stats, types, and moves, and construct custom teams saved locally.',
  category: 'Explore',
  icon: 'Layers',
  route: '/tools/pokedex',
  metaTitle: 'Pokédex & Team Builder — Search Pokémon Stats Online',
  metaDescription: 'Search the global Pokédex for any Pokémon to discover base stats, typing, and abilities. Construct custom 6-Pokémon squads saved on your browser.',
  keywords: [
    'pokedex online',
    'pokemon stats checker',
    'pokemon team builder',
    'search pokemon abilities',
    'pokeapi stats explorer',
    'build pokemon squad',
    'pokedex search index'
  ],
  longDescription: 'The Pokédex & Team Builder queries PokéAPI records to let fans explore base stats, movesets, typing, and official game sprites for all Pokémon. It features a custom "Team Builder" grid that saves up to 6 team members using localStorage.',
  howToUse: [
    'Type any Pokémon name (e.g., Charizard) or ID (e.g., 25) in the search field.',
    'Review the stats chart, types, abilities, and game sprites.',
    'Click "Add to Squad" to save the Pokémon to your custom 6-slot active team.',
    'Remove team members or clear the squad to build fresh combinations.'
  ],
  benefits: [
    'Fetches live database details directly from PokeAPI servers.',
    'Includes a client-side localStorage state manager to persist active squads.',
    'Runs fully client-side on mobile and desktop without cookies.'
  ],
  faq: [
    {
      question: 'Which Pokémon generations are covered?',
      answer: 'The underlying database includes records for all generations, from the classic Kanto Gen 1 up to the latest Paldea Gen 9 releases.'
    },
    {
      question: 'How does the Team Builder save my team?',
      answer: 'Your squad is saved directly to your browser\'s local storage (`localStorage`). It remains saved even if you refresh the page or restart your browser.'
    },
    {
      question: 'Why are some names failing to search?',
      answer: 'Make sure to search using lowercase characters, spelling them exactly (e.g. "pikachu" instead of "Pika!"). Special forms (like Mega or Alolan forms) are supported using official hyphenated names (e.g. "charizard-mega-y").'
    }
  ]
};
